import { useState } from 'react';
import service from "../../services/Service";
import { Button, notification } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import Loading from "../../utils/loading";

import { withLocale } from '../../l10n';

function SettingsJDE({ lang }) {
  // ===== 1. ESTADOS =====
  const [loading, setLoading] = useState(false);

  // ===== 2. HANDLERS =====
  const refreshWorkOrders = async () => {
    setLoading(true);
    try {
      await service.post("orders/wo/refresh")
      notification["success"]({
        message: lang.handle("Actualizado con exito"),
      });
    } catch (err) {
      console.log("Error devuelto: " + err);
      notification["error"]({
        message: lang.handle("Error al actualizar"),
      });
    } finally {
      setLoading(false);
    }
  };

  // ===== 3. RENDER =====
  return (
    <div>
      {loading && <Loading loading={loading} />}
      <div className='card card-body'>
        <h4 className="p-3"> {lang.handle("Actualización de listados")} </h4>

        <div className="row">
          <div className="col col-sm-3 my-auto">
            <div className='px-5'>{lang.handle("Actualizar listado de ordenes de trabajo")}</div>
          </div>
          <div className="col col-sm-9">
            <Button
              type="primary"
              icon={<ReloadOutlined />}
              disabled={loading}
              onClick={refreshWorkOrders}
            >
              {lang.handle('Refrescar ordenes de trabajo')}
            </Button>
          </div>
        </div>

      </div>
    </div>
  );
}

export default withLocale(SettingsJDE);
